import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import React, { memo } from "react";
import { RecordDetailsTabNames } from "@publicPortal/utils/enums";

interface PlanningApplicationTabsProps {
    currentTab: PlanningTabs;
    handleChangeTab: (newTab: PlanningTabs) => void;
    hideConstraintsTab?: boolean;
}

export const PublicPlanningApplicationTabs: PlanningTabs[] = [
    RecordDetailsTabNames.Summary,
    RecordDetailsTabNames.Constraints,
    RecordDetailsTabNames.Documents,
    RecordDetailsTabNames.Map,
    RecordDetailsTabNames.Comments,
    RecordDetailsTabNames.Consultations,
];

const PlanningApplicationTabs: React.FC<PlanningApplicationTabsProps> = memo((props) => {
    const { currentTab, handleChangeTab, hideConstraintsTab } = props;
    const visibleTabs: { [key in PlanningTabs]?: boolean } = {
        [RecordDetailsTabNames.Summary]: true,
        [RecordDetailsTabNames.Constraints]: !hideConstraintsTab,
        [RecordDetailsTabNames.Documents]: true,
        [RecordDetailsTabNames.Map]: true,
        [RecordDetailsTabNames.Comments]: true,
        [RecordDetailsTabNames.Consultations]: true,
    };
    const visibleTabsArray = Object.keys(visibleTabs).filter((key) => visibleTabs[key as PlanningTabs]);
    return (
        <Tabs
            aria-label="Planning Application Navigation Tabs"
            variant="scrollable"
            scrollButtons="auto"
            value={currentTab}
            onChange={(event, newTab: PlanningTabs) => handleChangeTab(newTab)}
            sx={{ margin: "2rem 0" }}
        >
            {visibleTabsArray.map((tabName) => {
                return <Tab key={tabName} disableRipple label={tabName} value={tabName} />;
            })}
        </Tabs>
    );
});

type PlanningTabs =
    | RecordDetailsTabNames.Summary
    | RecordDetailsTabNames.Constraints
    | RecordDetailsTabNames.Documents
    | RecordDetailsTabNames.Map
    | RecordDetailsTabNames.Comments
    | RecordDetailsTabNames.Consultations;

export default PlanningApplicationTabs;
export type { PlanningTabs };
